<template>
    <div class="log-line-icon-container" :style="{'background-color': color}">
        <log-line-icon :logLine="logLine"></log-line-icon>

        <button @click="$emit('toggle-sticky')" class="log-line-sticky-button" :class="{'log-line-sticky-button-selected': logLine.is_sticky}">
            <i class="fa fa-sticky-note"></i>
        </button>
    </div>
</template>

<script>
    import LogLineIcon from '@/components/LogLine/LogLineIcon'

    export default {
        components: {LogLineIcon},

        props: ['logLine'],

        computed: {
            color() {
                if (this.logLine.event === 'company-created' || this.logLine.event === 'person-created' || this.logLine.event === 'invoice-created' || this.logLine.event === 'subscription-created' || this.logLine.event === 'order-created' || this.logLine.event === 'order-confirmation-created' || this.logLine.event === 'opportunity-created' || this.logLine.event === 'email-created') {
                    return '#62d26f'
                }

                if (this.logLine.event === 'company-updated' || this.logLine.event === 'person-updated' || this.logLine.event === 'subscription-updated' || this.logLine.event === 'order-updated' || this.logLine.event === 'opportunity-updated') {
                    return '#eec300'
                }

                if (this.logLine.event === 'invoice-drafted') {
                    return '#8da3a6'
                }

                if (this.logLine.event === 'invoice-paid' || this.logLine.event === 'opportunity-converted-to-order'|| this.logLine.event === 'opportunity-converted-to-subscription') {
                    return '#aa62e3'
                }

                if (this.logLine.event === 'comment-created' || this.logLine.event === 'reminder-created') {
                    return '#20aaea'
                }

                if (this.logLine.event === 'opportunity-closed') {
                    return '#e8384f'
                }

                return '#8da3a6'
            }
        }
    }
</script>

<style>
    .log-line-icon-container {
        flex: 1;
        color: #ffffff;
        font-size: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        position: relative;
    }

    .log-line-sticky-button {
        position: absolute;
        bottom: 5px;
        right: 5px;
        font-size: 12px;
        background: transparent;
        border: none;
        padding: 0;
        line-height: 12px;
        opacity: 0.5;
    }

    .log-line-sticky-button-selected {
        opacity: 1;
    }
</style>
